<div class="close-cross">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="participantModal">
  <mat-card>
    <mat-card style="padding: 0px !important">
      <table mat-table matSort matSortDirection="desc" matSortActive="inscriptionDate" [dataSource]="datasource">
        <ng-container matColumnDef="inscriptionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "model.patient.creation" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.inscriptionDate | date : "short" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matSortDirection="asc">
            {{ "table.internalId" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.identifier }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lang">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "forms.userLang" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.lang }}
          </td>
        </ng-container>
        <ng-container matColumnDef="personnalData">
          <th mat-header-cell *matHeaderCellDef>
            {{ "forms.appointment.patientData" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" style="display: flex; flex-direction: column">
            <span *ngFor="let d of element.personnalData">{{ d }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ "table.action" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              [disabled]="isDownloading"
              matTooltip="{{ 'tpda.downloadConsentForms' | translate }}"
              aria-label="icon button with an download icon"
              *ngIf="('dashboard/TPDA/consentform' | isAuthorized | async) === true"
              (click)="downloadConsents(element)"
            >
              <mat-icon fontSet="fas" fontIcon="fa-file-download"></mat-icon>
            </button>
            <button
              mat-icon-button
              [disabled]="isDownloading"
              matTooltip="{{ 'tpda.downloadQRs' | translate }}"
              aria-label="icon button with an download icon"
              *ngIf="('dashboard/TPDA/QRsPDF' | isAuthorized | async) === true"
              (click)="downloadQRs(element)"
            >
              <mat-icon fontSet="fas" fontIcon="fa-file-archive"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator class="borderBox" #paginator [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" [hidePageSize]="false">
      </mat-paginator>
    </mat-card>
    <p class="text-center" *ngIf="!data.participants || data?.participants?.length === 0">
      {{ "widget.noData" | translate }}
    </p>
  </mat-card>
</div>
